package com.schoolconnect.app.feature.support

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppDialogBody
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogInputSize
import com.schoolconnect.app.designsystem.AppDialogLabelSize
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSearchSelectField
import com.schoolconnect.app.designsystem.AppDialogSectionLabel
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AdminSummaryMetrics
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.AppLabeledDropdownField
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPageScaffold
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListSummaryCardsShimmer
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminStatusChip
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.pageFooterText
import com.schoolconnect.app.feature.common.pageWindow
import com.schoolconnect.app.feature.common.shellAvatarInitials
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import io.github.vinceglb.filekit.core.PlatformFile
import io.ktor.http.ContentType
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.close_x
import ischoolconnect.sharedui.generated.resources.document
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.refresh_cw
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun SuperAdminSupportQueueScreen(
    roleLabel: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    val viewModel = remember { SupportQueueViewModel() }
    val state by viewModel.uiState.collectAsState()
    DisposableEffect(viewModel) { onDispose { viewModel.clear() } }
    var profileExpanded by remember { mutableStateOf(false) }
    val headerActions: @Composable RowScope.() -> Unit = {
        ShellTopRightActions(
            roleLabel = roleLabel,
            roleSubtitle = "Super Administrator",
            initials = shellAvatarInitials(roleLabel),
            expanded = profileExpanded,
            onExpandedChange = { profileExpanded = it },
            onChangeRole = onChangeRole,
            onLogout = onLogout
        )
    }
    val statusOptions = listOf("All Statuses", "Open", "In Progress", "Resolved", "Closed")
    val roleOptions = listOf(
        "All Roles",
        "School Admin",
        "School Management",
        "School Teacher",
        "School Support Staff",
        "Parent",
        "IT Super Admin",
        "IT Admin",
        "IT Support"
    )
    val periodOptions = listOf("All Time", "Today", "Last 7 Days", "Last 30 Days", "Last 90 Days")
    val displayStatus = state.status.ifBlank { "All Statuses" }
    val displayRole = state.requesterRole.ifBlank { "All Roles" }.let { code ->
        roleOptions.firstOrNull { it.toRequesterRoleCode() == code || it == code } ?: code
    }
    val openCount = state.tickets.count { displaySupportStatus(it.status) == "Open" }
    val inProgressCount = state.tickets.count { displaySupportStatus(it.status) == "In Progress" }
    val resolvedCount = state.tickets.count { displaySupportStatus(it.status) == "Resolved" }
    val closedCount = state.tickets.count { displaySupportStatus(it.status) == "Closed" }

    Box(Modifier.fillMaxSize().background(AppBackground)) {
        AdminListPageScaffold(
            title = "Support Center",
            subtitle = "Review and manage support tickets raised across schools.",
            breadcrumb = listOf("Platform Operations", "Support Center"),
            backgroundColor = AppBackground,
            titleColor = AppPageHeader,
            subtitleColor = AppPageSubtitle,
            maxContentWidth = 1500.dp,
            headerActions = headerActions,
            summaryCards = {
                if (state.isLoading) {
                    AdminListSummaryCardsShimmer(cardCount = 5)
                } else {
                    val summaryItems = listOf(
                        Triple("Total", state.totalCount.toString(), Res.drawable.document),
                        Triple("Open", openCount.toString(), Res.drawable.document),
                        Triple("In Progress", inProgressCount.toString(), Res.drawable.refresh_cw),
                        Triple("Resolved", resolvedCount.toString(), Res.drawable.circle_check),
                        Triple("Closed", closedCount.toString(), Res.drawable.document)
                    )
                    summaryItems.forEachIndexed { index, (title, value, icon) ->
                        val tone = AdminSummaryMetrics.gridTone(index, summaryItems.size)
                        AdminListSummaryCard(
                            title = title,
                            value = value,
                            subtitle = if (title == "Total") "All matching tickets" else "Current page",
                            icon = painterResource(icon),
                            accent = tone.accent,
                            accentBg = Color.White.copy(alpha = 0.72f),
                            subtitleColor = AppMuted,
                            surfaceColor = tone.soft,
                            borderColor = AdminSummaryMetrics.CardBorder,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            },
            toolbar = {
                SuperAdminSupportToolbar(
                    query = state.query,
                    role = displayRole,
                    roleOptions = roleOptions,
                    status = displayStatus,
                    statusOptions = statusOptions,
                    timeRange = state.periodRange,
                    periodOptions = periodOptions,
                    onQueryChanged = viewModel::searchChanged,
                    onRoleChanged = { value ->
                        viewModel.roleChanged(
                            if (value == "All Roles") "" else value.toRequesterRoleCode()
                        )
                    },
                    onStatusChanged = { value ->
                        viewModel.statusChanged(if (value == "All Statuses") "" else value)
                    },
                    onTimeRangeChanged = viewModel::periodChanged,
                    onResetFilters = viewModel::clearFilters
                )
            },
            table = { modifier ->
                SuperAdminSupportTable(
                    modifier = modifier,
                    tickets = state.tickets,
                    isLoading = state.isLoading,
                    errorMessage = state.errorMessage,
                    pageIndex = state.pageIndex,
                    pageSize = state.pageSize,
                    totalCount = state.totalCount,
                    sortBy = state.sortBy,
                    sortAscending = state.sortAscending,
                    onSortChanged = viewModel::sortChanged,
                    onPageChanged = viewModel::pageChanged,
                    onPageSizeChanged = viewModel::pageSizeChanged,
                    onRetry = viewModel::retry,
                    onViewTicket = viewModel::openViewTicket,
                    onEditTicket = viewModel::openEditTicket
                )
            },
            bottomAction = {
                AdminListPrimaryActionButton(
                    label = "Raise Ticket",
                    icon = painterResource(Res.drawable.plus),
                    onClick = viewModel::openRaiseDialog
                )
            }
        )
    }

    if (state.showRaiseDialog) {
        SuperAdminRaiseTicketDialog(
            schools = state.schools,
            assignees = state.assignees,
            isSaving = state.isRaiseSaving,
            errorMessage = state.raiseErrorMessage,
            onDismiss = viewModel::dismissRaiseDialog,
            onSubmit = { schoolId, subject, description, assigneeId, attachment ->
                viewModel.raiseTicket(
                    schoolId = schoolId,
                    subject = subject,
                    description = description,
                    assigneeId = assigneeId,
                    attachmentName = attachment?.name,
                    attachmentBytes = attachment?.bytes,
                    attachmentContentType = attachment?.contentType
                )
            }
        )
    }

    if (state.viewTicketId != null) {
        SuperAdminViewTicketDialog(
            detail = state.selectedDetail,
            isLoading = state.isDetailLoading,
            errorMessage = state.detailErrorMessage,
            onDismiss = viewModel::dismissTicketDialog,
            onRetry = viewModel::retryDetail
        )
    }

    if (state.editTicketId != null) {
        SuperAdminEditTicketDialog(
            detail = state.selectedDetail,
            assignees = state.assignees,
            isLoading = state.isDetailLoading,
            errorMessage = state.detailErrorMessage,
            isSaving = state.isEditSaving,
            saveErrorMessage = state.editErrorMessage,
            isReplying = state.isReplying,
            replyErrorMessage = state.replyErrorMessage,
            replyGeneration = state.replyGeneration,
            onDismiss = viewModel::dismissTicketDialog,
            onRetry = viewModel::retryDetail,
            onSave = { status, assigneeId -> viewModel.saveTicketEdits(status, assigneeId) },
            onReply = { message, attachment ->
                viewModel.replyToTicket(
                    message = message,
                    attachmentName = attachment?.name,
                    attachmentBytes = attachment?.bytes,
                    attachmentContentType = attachment?.contentType
                )
            }
        )
    }
}

@Composable
private fun SuperAdminSupportToolbar(
    query: String,
    role: String,
    roleOptions: List<String>,
    status: String,
    statusOptions: List<String>,
    timeRange: String,
    periodOptions: List<String>,
    onQueryChanged: (String) -> Unit,
    onRoleChanged: (String) -> Unit,
    onStatusChanged: (String) -> Unit,
    onTimeRangeChanged: (String) -> Unit,
    onResetFilters: () -> Unit
) {
    Row(
        Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(14.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        AdminListSearchField(
            query,
            onQueryChanged,
            "Search by Ticket ID, Subject, or School",
            width = 360.dp,
            height = 44.dp,
            modifier = Modifier.weight(1.4f)
        )
        AppLabeledDropdownField(
            label = "",
            value = role,
            options = roleOptions,
            onSelected = onRoleChanged,
            modifier = Modifier.weight(1f),
            includeAllOption = false,
            fieldHeight = 44.dp
        )
        AppLabeledDropdownField(
            label = "",
            value = status,
            options = statusOptions,
            onSelected = onStatusChanged,
            modifier = Modifier.weight(1f),
            includeAllOption = false,
            fieldHeight = 44.dp
        )
        AppLabeledDropdownField(
            label = "",
            value = timeRange,
            options = periodOptions,
            onSelected = onTimeRangeChanged,
            modifier = Modifier.weight(0.95f),
            includeAllOption = false,
            fieldHeight = 44.dp
        )
        AdminListToolbarButton(
            label = "Reset",
            icon = painterResource(Res.drawable.refresh_cw),
            onClick = onResetFilters,
            width = 112.dp,
            height = 44.dp,
            borderColor = AppPrimary,
            contentColor = AppPrimary,
            iconSize = 18.dp
        )
    }
}

@Composable
private fun SuperAdminSupportTable(
    modifier: Modifier,
    tickets: List<SupportQueueTicketUi>,
    isLoading: Boolean,
    errorMessage: String,
    pageIndex: Int,
    pageSize: Int,
    totalCount: Int,
    sortBy: String,
    sortAscending: Boolean,
    onSortChanged: (String, Boolean) -> Unit,
    onPageChanged: (Int) -> Unit,
    onPageSizeChanged: (Int) -> Unit,
    onRetry: () -> Unit,
    onViewTicket: (String) -> Unit,
    onEditTicket: (String) -> Unit
) {
    var rowsMenu by remember { mutableStateOf(false) }
    fun toggleSort(field: String) {
        onSortChanged(field, if (sortBy == field) !sortAscending else true)
    }
    val window = pageWindow(pageIndex, pageSize, totalCount)
    AdminListTableCard(
        modifier = modifier,
        minContentWidth = 1380.dp,
        header = {
            AdminListSortHeaderRow(
                listOf(
                    AdminListSortColumn("Ticket ID", 1.1f, sortBy == "ticket_id", sortAscending) { toggleSort("ticket_id") },
                    AdminListSortColumn("School Name", 1.45f, sortBy == "school_name", sortAscending) { toggleSort("school_name") },
                    AdminListSortColumn("Role", 1.05f, false, true) {},
                    AdminListSortColumn("Subject", 1.45f, sortBy == "subject", sortAscending) { toggleSort("subject") },
                    AdminListSortColumn("Raised On", 0.95f, sortBy == "created_at", sortAscending) { toggleSort("created_at") },
                    AdminListSortColumn("Status", 0.85f, sortBy == "status", sortAscending) { toggleSort("status") },
                    AdminListSortColumn("Assigned To", 1.1f, false, true) {}
                ),
                actionsLabel = "Actions",
                actionsWeight = 0.75f
            )
        },
        body = {
            if (isLoading) {
                AdminListTableShimmer(
                    columns = listOf(
                        AdminListHeaderColumn("Ticket ID", 1.1f),
                        AdminListHeaderColumn("School Name", 1.45f),
                        AdminListHeaderColumn("Role", 1.05f),
                        AdminListHeaderColumn("Subject", 1.45f),
                        AdminListHeaderColumn("Raised On", 0.95f),
                        AdminListHeaderColumn("Status", 0.85f),
                        AdminListHeaderColumn("Assigned To", 1.1f),
                        AdminListHeaderColumn("Actions", 0.75f)
                    ),
                    rowCount = pageSize.coerceAtLeast(5),
                    modifier = Modifier.fillMaxWidth(),
                    horizontalPadding = 24.dp
                )
            } else if (errorMessage.isNotBlank()) {
                Column(
                    Modifier.fillMaxWidth().heightIn(min = 220.dp),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center
                ) {
                    AppDialogErrorMessage(errorMessage)
                    Text("Retry", color = AppPrimary, fontWeight = FontWeight.Bold, modifier = Modifier.clickable(onClick = onRetry))
                }
            } else if (tickets.isEmpty()) {
                Box(Modifier.fillMaxWidth().heightIn(min = 220.dp), contentAlignment = Alignment.Center) {
                    AppText("No tickets found", color = AppNavy, fontWeight = FontWeight.Bold)
                }
            } else {
                AdminListTableBody(items = tickets, key = { it.id.ifBlank { it.ticketId } }, modifier = Modifier.fillMaxWidth()) { ticket ->
                    val rowKey = ticket.id.ifBlank { ticket.ticketId }
                    val lastKey = tickets.lastOrNull()?.let { it.id.ifBlank { it.ticketId } }
                    val showDivider = rowKey != lastKey
                    Column(Modifier.fillMaxWidth()) {
                        Row(
                            Modifier.fillMaxWidth().padding(horizontal = 24.dp, vertical = 15.dp),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            AdminListTableBodyText(ticket.ticketId, Modifier.weight(1.1f), color = AppNavy, fontWeight = FontWeight.SemiBold)
                            AdminListTableBodyText(ticket.schoolName, Modifier.weight(1.45f))
                            AdminListTableBodyText(displaySupportRole(ticket.requesterRole), Modifier.weight(1.05f))
                            AdminListTableBodyText(ticket.subject, Modifier.weight(1.45f))
                            AdminListTableBodyText(formatSupportDate(ticket.createdAt), Modifier.weight(0.95f))
                            Box(Modifier.weight(0.85f), contentAlignment = Alignment.CenterStart) {
                                SuperAdminStatusChip(displaySupportStatus(ticket.status))
                            }
                            AdminListTableBodyText(ticket.assignedToName, Modifier.weight(1.1f))
                            Row(
                                Modifier.weight(0.75f),
                                horizontalArrangement = Arrangement.spacedBy(4.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                IconButton(onClick = { onViewTicket(ticket.id) }, modifier = Modifier.size(32.dp)) {
                                    Icon(painterResource(Res.drawable.eye), "View ${ticket.ticketId}", tint = AppPrimary, modifier = Modifier.size(20.dp))
                                }
                                IconButton(onClick = { onEditTicket(ticket.id) }, modifier = Modifier.size(32.dp)) {
                                    Icon(painterResource(Res.drawable.pencil), "Edit ${ticket.ticketId}", tint = AppPrimary, modifier = Modifier.size(18.dp))
                                }
                            }
                        }
                        if (showDivider) {
                            // agents.md: table dividers 1px #E5E7EB (AppBorder)
                            Box(Modifier.fillMaxWidth().height(1.dp).background(AppBorder))
                        }
                    }
                }
            }
        },
        footer = {
            AdminListFooter(
                pageFooterText(window, "tickets"),
                window.pageIndex,
                window.pageCount,
                onPageChanged,
                pageSize,
                rowsMenu,
                { rowsMenu = !rowsMenu },
                { rowsMenu = false },
                onPageSizeChanged
            )
        }
    )
}

@Composable
private fun SuperAdminRaiseTicketDialog(
    schools: List<SupportSchoolOption>,
    assignees: List<SupportAssigneeOption>,
    isSaving: Boolean,
    errorMessage: String,
    onDismiss: () -> Unit,
    onSubmit: (schoolId: String, subject: String, description: String, assigneeId: String?, SupportTicketAttachment?) -> Unit
) {
    var schoolId by remember { mutableStateOf("") }
    var schoolLabel by remember { mutableStateOf("") }
    var subject by remember { mutableStateOf("") }
    var description by remember { mutableStateOf("") }
    var assigneeId by remember { mutableStateOf<String?>(null) }
    var assigneeLabel by remember { mutableStateOf("Unassigned") }
    var schoolQuery by remember { mutableStateOf("") }
    var assigneeQuery by remember { mutableStateOf("") }
    var schoolExpanded by remember { mutableStateOf(false) }
    var assigneeExpanded by remember { mutableStateOf(false) }
    var selectedFile by remember { mutableStateOf<PlatformFile?>(null) }
    var attachmentError by remember { mutableStateOf("") }
    var validationError by remember { mutableStateOf("") }
    val pickerScope = rememberCoroutineScope()
    val attachmentPicker = rememberFilePickerLauncher(
        type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png")),
        title = "Select Support Attachment"
    ) { file -> selectedFile = file; attachmentError = "" }
    val filteredSchools = remember(schools, schoolQuery) {
        val q = schoolQuery.trim()
        if (q.isBlank()) schools else schools.filter { it.name.contains(q, ignoreCase = true) }
    }
    val filteredAssignees = remember(assignees, assigneeQuery) {
        val q = assigneeQuery.trim()
        val base = if (q.isBlank()) assignees else assignees.filter { it.name.contains(q, ignoreCase = true) }
        base
    }

    AppDialogScaffold(
        onDismiss = { if (!isSaving) onDismiss() },
        size = AppDialogSize.Standard,
        dialogWidthOverride = 720.dp,
        maxDialogHeight = 820.dp,
        isLoading = isSaving,
        loadingTitle = "Saving support ticket"
    ) {
        AppDialogHeader(
            title = "Raise Ticket",
            subtitle = "Create a ticket for a school and optionally assign an IT user.",
            onClose = { if (!isSaving) onDismiss() },
            colors = AppDialogDefaultColors
        )
        AppDialogDivider()
        AppDialogBody(
            colors = AppDialogDefaultColors,
            horizontalPadding = 24.dp,
            verticalPadding = 22.dp,
            showVerticalScrollbar = true
        ) {
            val formError = validationError.ifBlank { errorMessage }
            if (formError.isNotBlank()) AppDialogErrorMessage(formError)
            AppDialogFieldColumn("School", required = true, colors = AppDialogDefaultColors) {
                AppDialogSearchSelectField(
                    value = schoolLabel,
                    placeholder = "Select school",
                    query = schoolQuery,
                    expanded = schoolExpanded,
                    options = filteredSchools,
                    optionLabel = { it.name },
                    onQueryChange = { schoolQuery = it },
                    onToggleExpanded = { schoolExpanded = !schoolExpanded },
                    onDismissExpanded = { schoolExpanded = false; schoolQuery = "" },
                    onSelected = {
                        schoolId = it.id
                        schoolLabel = it.name
                        schoolExpanded = false
                        schoolQuery = ""
                        if (validationError.isNotBlank()) validationError = ""
                    },
                    colors = AppDialogDefaultColors,
                    searchPlaceholder = "Search schools"
                )
            }
            AppDialogFieldColumn("Subject", required = true, colors = AppDialogDefaultColors) {
                AppDialogTextField(
                    value = subject,
                    onValueChange = {
                        subject = it
                        if (validationError.isNotBlank()) validationError = ""
                    },
                    placeholder = "Enter a brief subject",
                    colors = AppDialogDefaultColors
                )
            }
            AppDialogFieldColumn("Description", required = true, colors = AppDialogDefaultColors) {
                AppDialogTextField(
                    value = description,
                    onValueChange = {
                        description = it
                        if (validationError.isNotBlank()) validationError = ""
                    },
                    placeholder = "Describe the issue in detail",
                    colors = AppDialogDefaultColors,
                    singleLine = false,
                    fieldHeight = 120.dp
                )
            }
            AppDialogFieldColumn("Assigned To", helperText = "Optional", colors = AppDialogDefaultColors) {
                AppDialogSearchSelectField(
                    value = assigneeLabel,
                    placeholder = "Unassigned",
                    query = assigneeQuery,
                    expanded = assigneeExpanded,
                    options = listOf(SupportAssigneeOption("", "Unassigned")) + filteredAssignees,
                    optionLabel = { it.name },
                    onQueryChange = { assigneeQuery = it },
                    onToggleExpanded = { assigneeExpanded = !assigneeExpanded },
                    onDismissExpanded = { assigneeExpanded = false; assigneeQuery = "" },
                    onSelected = {
                        assigneeId = it.userId.takeIf { id -> id.isNotBlank() }
                        assigneeLabel = it.name
                        assigneeExpanded = false
                        assigneeQuery = ""
                    },
                    colors = AppDialogDefaultColors,
                    searchPlaceholder = "Search IT users"
                )
            }
            AppDialogFieldColumn("Attachment", helperText = "Optional", colors = AppDialogDefaultColors) {
                AppOutlinedButton(
                    onClick = { attachmentPicker.launch() },
                    modifier = Modifier.height(40.dp),
                    colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                    border = BorderStroke(1.dp, AppBorder),
                    shape = RoundedCornerShape(8.dp),
                    contentPadding = PaddingValues(horizontal = 14.dp)
                ) {
                    Icon(painterResource(Res.drawable.document), null, modifier = Modifier.size(18.dp))
                    Spacer(Modifier.width(8.dp))
                    Text(selectedFile?.name ?: "Add Attachment", fontSize = 14.sp, fontWeight = FontWeight.Medium, maxLines = 1, overflow = TextOverflow.Ellipsis)
                }
                if (attachmentError.isNotBlank()) AppText(attachmentError, color = AppDanger, style = MaterialTheme.typography.bodySmall)
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Cancel", { if (!isSaving) onDismiss() }, AppDialogActionStyle.Secondary, width = 108.dp, enabled = !isSaving),
                AppDialogFooterAction(if (isSaving) "Saving…" else "Save", {
                    if (isSaving) return@AppDialogFooterAction
                    validationError = when {
                        schoolId.isBlank() -> "Select a school."
                        subject.isBlank() -> "Enter a subject."
                        description.isBlank() -> "Enter a description."
                        else -> ""
                    }
                    if (validationError.isNotBlank()) return@AppDialogFooterAction
                    if (selectedFile == null) {
                        onSubmit(schoolId, subject.trim(), description.trim(), assigneeId, null)
                    } else {
                        pickerScope.launch {
                            runCatching { selectedFile!!.readBytes() }
                                .onSuccess { bytes ->
                                    if (bytes.isEmpty()) attachmentError = "Unable to read ${selectedFile!!.name}."
                                    else onSubmit(
                                        schoolId,
                                        subject.trim(),
                                        description.trim(),
                                        assigneeId,
                                        SupportTicketAttachment(selectedFile!!.name, bytes, supportAttachmentContentType(selectedFile!!.name))
                                    )
                                }
                                .onFailure { attachmentError = "Unable to read ${selectedFile!!.name}." }
                        }
                    }
                }, AppDialogActionStyle.Primary, enabled = !isSaving, width = 108.dp)
            ),
            colors = AppDialogDefaultColors,
            equalWeightButtons = false
        )
    }
}

@Composable
private fun SuperAdminViewTicketDialog(
    detail: SupportQueueTicketDetailUi?,
    isLoading: Boolean,
    errorMessage: String,
    onDismiss: () -> Unit,
    onRetry: () -> Unit
) {
    val waitingForDetail = isLoading && detail == null && errorMessage.isBlank()
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        dialogWidthOverride = 860.dp,
        maxDialogHeight = 820.dp,
        fillDialogHeight = true,
        isLoading = waitingForDetail,
        loadingTitle = "Loading ticket"
    ) {
        SuperAdminViewTicketHeader(
            createdBy = detail?.requesterName.orEmpty(),
            createdOn = formatSupportDate(detail?.createdAt.orEmpty()),
            updatedOn = formatSupportDate(detail?.updatedAt.orEmpty().ifBlank { detail?.createdAt.orEmpty() }),
            onClose = onDismiss
        )
        AppDialogDivider()
        AppDialogBody(
            horizontalPadding = 24.dp,
            verticalPadding = 18.dp,
            showVerticalScrollbar = true,
            fillAvailable = true
        ) {
            when {
                errorMessage.isNotBlank() && detail == null -> {
                    AppDialogErrorMessage(errorMessage)
                    AppOutlinedButton(onClick = onRetry, modifier = Modifier.height(38.dp), border = BorderStroke(1.dp, AppBorder), contentPadding = PaddingValues(horizontal = 14.dp)) {
                        Text("Retry")
                    }
                }
                detail != null -> {
                    if (errorMessage.isNotBlank()) AppDialogErrorMessage(errorMessage)
                    SuperAdminTicketReadOnlyGrid(detail = detail, includeStatusAndAssignee = true)
                    when {
                        detail.description.isNotBlank() -> SuperAdminTicketValue("Description", detail.description)
                        isLoading -> AppText("Loading description…", color = AppMuted)
                    }
                    AppDialogDivider()
                    AppDialogSectionLabel("Conversation History", colors = AppDialogDefaultColors, fontSize = 16.sp)
                    when {
                        isLoading && detail.conversation.isEmpty() -> AppText("Loading conversation…", color = AppMuted)
                        detail.conversation.isEmpty() -> AppText("No conversation yet.", color = AppMuted)
                        else -> {
                            detail.conversation.forEach { message ->
                                SuperAdminConversationMessage(message)
                            }
                        }
                    }
                }
                else -> Spacer(Modifier.height(120.dp))
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Primary, width = 108.dp)),
            colors = AppDialogDefaultColors,
            equalWeightButtons = false
        )
    }
}

@Composable
private fun SuperAdminEditTicketDialog(
    detail: SupportQueueTicketDetailUi?,
    assignees: List<SupportAssigneeOption>,
    isLoading: Boolean,
    errorMessage: String,
    isSaving: Boolean,
    saveErrorMessage: String,
    isReplying: Boolean,
    replyErrorMessage: String,
    replyGeneration: Int,
    onDismiss: () -> Unit,
    onRetry: () -> Unit,
    onSave: (statusDisplay: String, assigneeUserId: String?) -> Unit,
    onReply: (String, SupportTicketAttachment?) -> Unit
) {
    var status by remember(detail?.id, detail?.status) { mutableStateOf(displaySupportStatus(detail?.status.orEmpty())) }
    var assigneeId by remember(detail?.id, detail?.assignedToId) { mutableStateOf(detail?.assignedToId?.takeIf { it.isNotBlank() }) }
    var assigneeLabel by remember(detail?.id, detail?.assignedToName) { mutableStateOf(detail?.assignedToName?.ifBlank { "Unassigned" } ?: "Unassigned") }
    var assigneeQuery by remember { mutableStateOf("") }
    var assigneeExpanded by remember { mutableStateOf(false) }
    var reply by remember { mutableStateOf("") }
    var selectedFile by remember { mutableStateOf<PlatformFile?>(null) }
    var attachmentError by remember { mutableStateOf("") }
    var replyValidationError by remember { mutableStateOf("") }
    val pickerScope = rememberCoroutineScope()
    val attachmentPicker = rememberFilePickerLauncher(
        type = PickerType.File(listOf("pdf", "doc", "docx", "xls", "xlsx", "jpg", "jpeg", "png")),
        title = "Select Reply Attachment"
    ) { file -> selectedFile = file; attachmentError = "" }
    LaunchedEffect(replyGeneration) {
        if (replyGeneration > 0) {
            reply = ""
            selectedFile = null
            attachmentError = ""
            replyValidationError = ""
        }
    }
    val filteredAssignees = remember(assignees, assigneeQuery) {
        val q = assigneeQuery.trim()
        if (q.isBlank()) assignees else assignees.filter { it.name.contains(q, ignoreCase = true) }
    }
    val busy = isSaving || isReplying
    val waitingForDetail = isLoading && detail == null && errorMessage.isBlank()

    AppDialogScaffold(
        onDismiss = { if (!busy) onDismiss() },
        size = AppDialogSize.Wide,
        dialogWidthOverride = 860.dp,
        maxDialogHeight = 860.dp,
        fillDialogHeight = true,
        isLoading = busy || waitingForDetail,
        loadingTitle = when {
            waitingForDetail -> "Loading ticket"
            isReplying -> "Sending reply"
            else -> "Saving ticket"
        }
    ) {
        AppDialogHeader(
            title = "Edit Ticket",
            subtitle = "Update assignment, status, and reply to the requester.",
            onClose = { if (!busy) onDismiss() },
            colors = AppDialogDefaultColors
        )
        AppDialogDivider()
        AppDialogBody(
            horizontalPadding = 24.dp,
            verticalPadding = 18.dp,
            showVerticalScrollbar = true,
            fillAvailable = true
        ) {
            when {
                errorMessage.isNotBlank() && detail == null -> {
                    AppDialogErrorMessage(errorMessage)
                    AppOutlinedButton(onClick = onRetry, modifier = Modifier.height(38.dp), border = BorderStroke(1.dp, AppBorder), contentPadding = PaddingValues(horizontal = 14.dp)) {
                        Text("Retry")
                    }
                }
                detail != null -> {
                    if (errorMessage.isNotBlank()) AppDialogErrorMessage(errorMessage)
                    if (saveErrorMessage.isNotBlank()) AppDialogErrorMessage(saveErrorMessage)
                    SuperAdminTicketReadOnlyGrid(detail = detail, includeStatusAndAssignee = false)
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.spacedBy(28.dp)
                    ) {
                        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            AppDialogSectionLabel("Current Status", colors = AppDialogDefaultColors, fontSize = 13.sp)
                            AppLabeledDropdownField(
                                "",
                                status,
                                listOf("Open", "In Progress", "Resolved", "Closed"),
                                { status = it },
                                Modifier.fillMaxWidth(),
                                includeAllOption = false
                            )
                        }
                        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(10.dp)) {
                            AppDialogSectionLabel("Assigned To", colors = AppDialogDefaultColors, fontSize = 13.sp)
                            AppDialogSearchSelectField(
                                value = assigneeLabel,
                                placeholder = "Unassigned",
                                query = assigneeQuery,
                                expanded = assigneeExpanded,
                                options = listOf(SupportAssigneeOption("", "Unassigned")) + filteredAssignees,
                                optionLabel = { it.name },
                                onQueryChange = { assigneeQuery = it },
                                onToggleExpanded = { assigneeExpanded = !assigneeExpanded },
                                onDismissExpanded = { assigneeExpanded = false; assigneeQuery = "" },
                                onSelected = {
                                    assigneeId = it.userId.takeIf { id -> id.isNotBlank() }
                                    assigneeLabel = it.name
                                    assigneeExpanded = false
                                    assigneeQuery = ""
                                },
                                colors = AppDialogDefaultColors,
                                searchPlaceholder = "Search IT users"
                            )
                        }
                    }
                    AppDialogDivider()
                    AppDialogSectionLabel("Conversation History", colors = AppDialogDefaultColors, fontSize = 16.sp)
                    when {
                        isLoading && detail.conversation.isEmpty() -> AppText("Loading conversation…", color = AppMuted)
                        detail.conversation.isEmpty() -> AppText("No conversation yet.", color = AppMuted)
                        else -> {
                            detail.conversation.forEach { message ->
                                SuperAdminConversationMessage(message)
                            }
                        }
                    }
                    val replyError = replyValidationError.ifBlank { replyErrorMessage }
                    if (replyError.isNotBlank()) AppDialogErrorMessage(replyError)
                    AppDialogFieldColumn("Reply", colors = AppDialogDefaultColors) {
                        AppDialogTextField(
                            value = reply,
                            onValueChange = {
                                reply = it
                                if (replyValidationError.isNotBlank()) replyValidationError = ""
                            },
                            placeholder = "Type your reply",
                            colors = AppDialogDefaultColors,
                            singleLine = false,
                            fieldHeight = 100.dp,
                            maxLength = 2000
                        )
                    }
                    AppOutlinedButton(
                        onClick = { attachmentPicker.launch() },
                        modifier = Modifier.height(40.dp),
                        colors = ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary),
                        border = BorderStroke(1.dp, AppBorder),
                        shape = RoundedCornerShape(8.dp),
                        contentPadding = PaddingValues(horizontal = 14.dp)
                    ) {
                        Icon(painterResource(Res.drawable.document), null, modifier = Modifier.size(18.dp))
                        Spacer(Modifier.width(8.dp))
                        Text(selectedFile?.name ?: "Add Attachment", fontSize = 14.sp, fontWeight = FontWeight.Medium)
                    }
                    if (attachmentError.isNotBlank()) AppText(attachmentError, color = AppDanger, style = MaterialTheme.typography.bodySmall)
                }
                else -> Spacer(Modifier.height(120.dp))
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Cancel", { if (!busy) onDismiss() }, AppDialogActionStyle.Secondary, width = 108.dp, enabled = !busy),
                AppDialogFooterAction(
                    if (isSaving) "Saving…" else "Save",
                    { if (detail != null && !busy) onSave(status, assigneeId) },
                    AppDialogActionStyle.Secondary,
                    enabled = detail != null && !busy,
                    width = 108.dp
                ),
                AppDialogFooterAction(
                    if (isReplying) "Sending…" else "Send Reply",
                    {
                        if (busy || detail == null) return@AppDialogFooterAction
                        if (reply.isBlank()) {
                            replyValidationError = "Enter a reply."
                            return@AppDialogFooterAction
                        }
                        replyValidationError = ""
                        if (selectedFile == null) onReply(reply.trim(), null)
                        else pickerScope.launch {
                            val file = selectedFile ?: return@launch
                            runCatching { file.readBytes() }
                                .onSuccess { bytes ->
                                    if (bytes.isEmpty()) attachmentError = "Unable to read ${file.name}."
                                    else onReply(reply.trim(), SupportTicketAttachment(file.name, bytes, supportAttachmentContentType(file.name)))
                                }
                                .onFailure { attachmentError = "Unable to read ${file.name}." }
                        }
                    },
                    AppDialogActionStyle.Primary,
                    enabled = !busy && detail != null,
                    width = 140.dp
                )
            ),
            colors = AppDialogDefaultColors,
            equalWeightButtons = false
        )
    }
}

@Composable
private fun SuperAdminViewTicketHeader(
    createdBy: String,
    createdOn: String,
    updatedOn: String,
    onClose: () -> Unit
) {
    val createdLabel = createdBy.ifBlank { "—" }
    val createdDate = createdOn.ifBlank { "—" }
    val updatedDate = updatedOn.ifBlank { createdDate }
    val auditText = buildAnnotatedString {
        val labelStyle = SpanStyle(fontWeight = FontWeight.SemiBold, color = AppMuted)
        val valueStyle = SpanStyle(fontWeight = FontWeight.Normal, color = AppMuted)
        withStyle(labelStyle) { append("Created by") }
        withStyle(valueStyle) { append(" $createdLabel · $createdDate | ") }
        withStyle(labelStyle) { append("Last modified by") }
        withStyle(valueStyle) { append(" — · $updatedDate") }
    }
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(start = 24.dp, end = 20.dp, top = 16.dp, bottom = 12.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.Top
    ) {
        Column(
            modifier = Modifier.weight(1f).padding(end = 16.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            Text("View Ticket", color = AppPrimary, fontSize = 20.sp, fontWeight = FontWeight.Bold, maxLines = 1)
            Text(
                "Review ticket details and conversation history.",
                color = AppMuted,
                fontSize = 13.sp,
                fontWeight = FontWeight.Normal,
                maxLines = 2
            )
            Text(auditText, fontSize = 12.sp, lineHeight = 18.sp)
        }
        Box(
            modifier = Modifier.size(32.dp).clickable(onClick = onClose),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(Res.drawable.close_x),
                contentDescription = "Close",
                tint = AppMuted,
                modifier = Modifier.size(20.dp)
            )
        }
    }
}

@Composable
private fun SuperAdminTicketReadOnlyGrid(
    detail: SupportQueueTicketDetailUi,
    includeStatusAndAssignee: Boolean
) {
    Column(
        Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        SuperAdminTicketValueRow("Ticket ID", detail.ticketId, "Subject", detail.subject)
        SuperAdminTicketValueRow("School Name", detail.schoolName, "Raised By", detail.requesterName)
        SuperAdminTicketValueRow(
            "Role",
            displaySupportRole(detail.requesterRole),
            "Raised On",
            formatSupportDate(detail.createdAt)
        )
        if (includeStatusAndAssignee) {
            Row(
                Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(28.dp)
            ) {
                Box(modifier = Modifier.weight(1f)) {
                    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                        Text("Current Status", color = AppNavy, fontSize = AppDialogLabelSize, fontWeight = FontWeight.SemiBold)
                        SuperAdminStatusChip(displaySupportStatus(detail.status))
                    }
                }
                SuperAdminTicketValue(
                    label = "Assigned To",
                    value = detail.assignedToName,
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}

@Composable
private fun SuperAdminConversationMessage(message: SupportQueueConversationMessageUi) {
    val whenLabel = formatSupportDateTime(message.createdAt).ifBlank { "—" }
    Column(
        Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(6.dp)
    ) {
        Row(
            Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                message.senderName.ifBlank { "User" },
                color = AppNavy,
                fontSize = AppDialogInputSize,
                fontWeight = FontWeight.SemiBold,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.weight(1f, fill = false)
            )
            Text(
                whenLabel,
                color = AppMuted,
                fontSize = 12.sp,
                fontWeight = FontWeight.Normal,
                maxLines = 1
            )
        }
        Surface(
            Modifier.fillMaxWidth(),
            color = Color.White,
            shape = RoundedCornerShape(8.dp),
            border = BorderStroke(1.dp, AppBorder)
        ) {
            Text(
                message.message.ifBlank { "—" },
                color = AppNavy,
                fontSize = AppDialogInputSize,
                fontWeight = FontWeight.Normal,
                modifier = Modifier.padding(14.dp)
            )
        }
    }
}

@Composable
private fun SuperAdminTicketValueRow(
    leftLabel: String,
    leftValue: String,
    rightLabel: String,
    rightValue: String
) {
    Row(
        Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(28.dp)
    ) {
        SuperAdminTicketValue(leftLabel, leftValue, Modifier.weight(1f))
        SuperAdminTicketValue(rightLabel, rightValue, Modifier.weight(1f))
    }
}

@Composable
private fun SuperAdminTicketValue(
    label: String,
    value: String,
    modifier: Modifier = Modifier
) {
    Column(
        modifier,
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        Text(label, color = AppNavy, fontSize = AppDialogLabelSize, fontWeight = FontWeight.SemiBold)
        Text(value.ifBlank { "—" }, color = AppNavy, fontSize = AppDialogInputSize, fontWeight = FontWeight.Normal)
    }
}

@Composable
private fun SuperAdminStatusChip(status: String) {
    val color = when (status) {
        "Open" -> AppDanger
        "In Progress" -> AppWarning
        "Resolved" -> AppPrimary
        else -> AppMuted
    }
    val background = when (status) {
        "Open" -> AppDangerSoft
        "In Progress" -> AppWarningSoft
        "Resolved" -> AppPrimarySoft
        else -> AppSecondaryBackground
    }
    AdminStatusChip(status, color, background, dotColor = color)
}

private fun String.toRequesterRoleCode(): String = when (trim()) {
    "School Admin" -> "SCHOOL_ADMIN"
    "School Management" -> "SCHOOL_MGMT"
    "School Teacher" -> "SCHOOL_TEACHER"
    "School Support Staff" -> "SCHOOL_SUPPORT_STAFF"
    "Parent" -> "PARENT"
    "IT Super Admin" -> "IT_SUPER_ADMIN"
    "IT Admin" -> "IT_ADMIN"
    "IT Support" -> "IT_SUPPORT"
    else -> trim().uppercase().replace(' ', '_')
}

private fun displaySupportStatus(value: String): String = when (value.trim().uppercase()) {
    "IN_PROGRESS" -> "In Progress"
    "OPEN" -> "Open"
    "RESOLVED" -> "Resolved"
    "CLOSED" -> "Closed"
    else -> value.ifBlank { "Unknown" }
}

private fun displaySupportRole(value: String): String {
    val normalized = value.trim().replace('_', ' ').replace('-', ' ')
    if (normalized.isBlank()) return "—"
    return normalized
        .lowercase()
        .split(Regex("\\s+"))
        .filter { it.isNotBlank() }
        .joinToString(" ") { part ->
            part.replaceFirstChar { char -> if (char.isLowerCase()) char.titlecase() else char.toString() }
        }
}

private fun formatSupportDate(value: String): String {
    val parts = value.trim().substringBefore("T").split("-")
    if (parts.size != 3) return value
    val months = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
    val month = parts[1].toIntOrNull()?.let { months.getOrNull(it - 1) } ?: return value
    return "${parts[2].take(2)} $month ${parts[0]}"
}

private fun formatSupportDateTime(value: String): String {
    val raw = value.trim()
    if (raw.isBlank()) return ""
    val dateLabel = formatSupportDate(raw)
    if (dateLabel == raw || !raw.contains('T')) return dateLabel
    val timePart = raw.substringAfter('T', "").substringBefore('Z').substringBefore('+').take(5)
    val hour = timePart.substringBefore(':').toIntOrNull()
    val minute = timePart.substringAfter(':', "").toIntOrNull()
    if (hour == null || minute == null || hour !in 0..23 || minute !in 0..59) return dateLabel
    val meridiem = if (hour >= 12) "PM" else "AM"
    val displayHour = when (val normalized = hour % 12) {
        0 -> 12
        else -> normalized
    }
    return "$dateLabel, ${displayHour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} $meridiem"
}

private fun supportAttachmentContentType(fileName: String): ContentType = when (fileName.substringAfterLast('.', "").lowercase()) {
    "pdf" -> ContentType.Application.Pdf
    "jpg", "jpeg" -> ContentType.Image.JPEG
    "png" -> ContentType.Image.PNG
    "doc" -> ContentType.parse("application/msword")
    "docx" -> ContentType.parse("application/vnd.openxmlformats-officedocument.wordprocessingml.document")
    "xls" -> ContentType.parse("application/vnd.ms-excel")
    "xlsx" -> ContentType.parse("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    else -> ContentType.Application.OctetStream
}
